import { Button, Grid } from "@mui/material";
import * as React from "react";
import SectionTitleWithAction from "../SectionTitle/SectionTitleWithAction";
import ActivatePaygDialog from "./ActivatePaygDialog";
import PricingItem from "./PricingItem";
import HistoryEduOutlinedIcon from "@mui/icons-material/HistoryEduOutlined";
import { ToastContainer } from "react-toastify";

interface Props {
    organizationId: string;
    detailsFilledIn: boolean;
}

export default function BillingPricing({ organizationId, detailsFilledIn }: Props) {
    const [openActivateDialog, setOpenActivateDialog] = React.useState<boolean>(false);

    return (
        <>
            <div style={{ marginTop: "12px" }}>
                <SectionTitleWithAction title="Choose your plan" />
                <Grid container spacing={4} justifyContent="space-evenly" style={{ marginTop: "48px" }}>
                    <PricingItem
                        color="secondary"
                        title={"Commitment"}
                        icon={<HistoryEduOutlinedIcon color="secondary" style={{ fontSize: "60px" }} />}
                        button={
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={() => window.open(`https://www.theoplayer.com/contact`)}
                            >
                                Contact us
                            </Button>
                        }
                        items={["Discount for high volumes", "Annual contracts", "Option to bring your own CDN"]}
                    />
                </Grid>
            </div>
            <ActivatePaygDialog
                onClose={() => setOpenActivateDialog(false)}
                open={openActivateDialog}
                organizationId={organizationId}
            />
            <ToastContainer />
        </>
    );
}
